export const GET_FEED_ANALYTICS = "GET_FEED_ANALYTICS"
export const GET_FEED_ANALYTICS_SUCCESS = "GET_FEED_ANALYTICS_SUCCESS"
export const GET_FEED_ANALYTICS_FAIL = "GET_FEED_ANALYTICS_FAIL"
// export const DELETE_WARDROBE_ITEM = "DELETE_WARDROBE_ITEM"
export const CLEAR_FEED_ANALYTICS = "CLEAR_FEED_ANALYTICS"
export const SET_FEED_ANALYTICS_QUERY_OBJECT = "SET_FEED_ANALYTICS_QUERY_OBJECT"